import axios from "axios";
import { getBackendUrl } from "@/general";


export const importFileRentedProducts = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/movimientos/api/importacionProductosArrendamiento`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.error(err);
    throw err.response;
  }
}

export const saveElectronicDocumentOnPurchaseInvoice = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/movimientos/api/grabaFacturaCompraDIAN`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    throw err.response;
  }
}